import React from 'react'

class Services extends React.Component {
  render() {
    return (
 <div id="services">
    <div className="container">
        <div className="row service-box">
           <div className="col-md-4 text-center">
             <i className="fa-solid fa-thumbs-up"></i>
              <h4 className="feat mb-3">High Quality</h4>
                 <p>We provide premium products that are of high quality, long lasting and durable.</p>
            </div> 
           <div className="col-md-4 text-center service-box">
              <i className="fa-solid fa-truck-fast"></i>
               <h4 className="feat mb-3">fast Delivery</h4>
                  <p>We assure you that your purchased items gets to your door step as fast as possible.</p>
            </div>     
           <div className="col-md-4 text-center service-box">
                <i className="fa-solid fa-comments"></i>
                <h4 className="feat mb-3">Customer Service</h4>
                  <p>Get personalized support and thoughtful recommendations directly from the owners and professional staff.</p>
            </div>
       </div>
    </div>
 </div>   
    )
  }
}

export default Services;